// extracted by mini-css-extract-plugin
export default {"container":"Skills_container__5+yxw","mymove":"Skills_mymove__QzlY7","div":"Skills_div__e+Ffa","icon":"Skills_icon__BYLYI","title":"Skills_title__DU1mm"};